// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Gallery_wrapper__Ooy4g","image":"Gallery_image__4M8BE","imageIn":"Gallery_imageIn__JzrvT"};